import { Toaster as Sonner } from 'sonner';
import { useIsPhone } from '../lib/use-media-query';
import { Icon } from './icon';

export { toast } from 'sonner';

/**
 * Toasts for success and errors after an action (docs/ui/design-system.md). Top on the phone,
 * where the bottom bar and the thumb are, bottom right elsewhere.
 */
export function Toaster({ theme }: { theme: 'light' | 'dark' }) {
  const phone = useIsPhone();
  return (
    <Sonner
      theme={theme}
      position={phone ? 'top-center' : 'bottom-right'}
      gap={8}
      visibleToasts={4}
      icons={{
        success: <Icon name="circle-check" className="text-success" />,
        error: <Icon name="circle-alert" className="text-danger" />,
        warning: <Icon name="triangle-alert" className="text-warning" />,
        info: <Icon name="info" className="text-info" />,
        loading: <Icon name="loader-circle" className="animate-spin text-fg-subtle" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex w-full items-start gap-3 rounded-lg border border-line bg-raised p-3.5 text-sm text-fg shadow-overlay md:w-(--width)',
          title: 'font-medium',
          description: 'mt-0.5 text-fg-muted',
          icon: 'mt-0.5 shrink-0',
          content: 'min-w-0 flex-1',
          actionButton:
            'h-control-sm shrink-0 cursor-pointer rounded-md bg-accent-solid px-2.5 font-medium text-accent-solid-fg hover:bg-accent-solid-hover',
          cancelButton:
            'h-control-sm shrink-0 cursor-pointer rounded-md px-2.5 font-medium text-fg-muted hover:bg-hover',
        },
      }}
    />
  );
}
